import React from 'react';

export type EditOAuthConnectionDialogPromptProps = Readonly<{
  prompt: string;
}>;

export function EditOAuthConnectionDialogPrompt(props: EditOAuthConnectionDialogPromptProps) {
  return (
    <>
      < div className="tb-margin-bottom-wide">
        {props.prompt}
      </div >
    </>
  );
}
